<template>
  <div
    id="container"
    class="d-flex justify-content-center align-items-center w-100"
  >
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="true"></loading>
    </div>
    <Logo />

    <form
      id="form"
      class="d-flex flex-column"
      @submit.prevent="login"
      style="transition: all 0.5s ease-in-out"
    >
      <span>
        <h1
          style="
            font-style: normal;
            font-weight: 700;
            font-size: 34px;
            margin-bottom: 10px;
          "
        >
          Faça login
        </h1>
        <p
          style="
            color: var(--grey-medium);
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 0;
            max-width: 329px;
          "
        >
          Informa abaixo suas credenciais de acesso ao sistema.
        </p>
      </span>
      <div
        class="d-flex flex-column w-100 justify-content-between align-items-start"
        style="margin-top: 48px"
      >
        <Input
          inputId="email"
          inputType="email"
          :inputValue="user.email"
          inputLabel="Digite seu CPF/CNPJ ou email"
          inputName="Login"
          @onUpdate="(value) => handleInputValue('email', value)"
          :required="true"
          :isValid="isOkEmail"
          @isValid="isValid()"
        />
        <Input
          inputId="password"
          :isValid="isOkResponse"
          :inputType="typePassword"
          :inputValue="user.password"
          inputLabel="Insira sua senha"
          inputName="Password"
          @onUpdate="(value) => handleInputValue('password', value)"
          style="margin-top: 24px"
          :required="true"
          @clickVerSenha="clickVerSenha()"
          @isValid="isValid()"
        />
        <p
          v-if="showAlert"
          style="
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            margin: 5px 0;
            color: var(--red-medium);
          "
        >
          {{ responseText }}
        </p>
      </div>
      <div
        class="d-flex justify-content-between w-100 align-items-center"
        style="margin-top: 25px"
      >
        <div class="d-flex justify-content-start align-items-center w-100">
          <!-- TODO: Config componente Input para aceitar outros types, sem label e ajuste de estilização -->
          <input type="checkbox" name="lembrar-me" style="margin-right: 8px" />
          <label
            for="lembrar-me"
            style="
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              color: var(--grey-medium);
            "
            >Lembrar-me</label
          >
        </div>
        <router-link
          class="w-100"
          style="font-style: normal; font-weight: 400; font-size: 14px;color:color: #2485EA;text-decoration:none;text-align: end;"
          :to="{ name: 'ForgotPassword' }"
        >
          Esqueci minha senha
        </router-link>
      </div>
      <div style="margin-top: 42px">
        <button
          class="btn-default"
          :class="isDisabled ? 'btnUntyped' : 'btnTyped'"
          type="submit"
          style="color: var(--white)"
          :disabled="isDisabled"
        >
          Entrar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Input from "../components/Input.vue";
import Logo from "@/components/Logo.vue";
import Loading from "vue-loading-overlay";

export default {
  name: "Login",
  components: {
    Input,
    Logo,
    Loading,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      typePassword: "",
      isOkEmail: false,
      isOkResponse: false,
      responseText: "",
      statusCode: 0,
      showAlert: false,
      isDisabled: true,
      isLoading: false,
    };
  },
  created() {
    this.typePassword = "password";
  },
  methods: {
    ...mapActions(["auth"]),
    ...mapMutations(["setToken"]),

    async login() {
      this.isLoading = true;
      try {
        const response = await this.auth(this.user);
        const objToken = this.parseJwt(response.data.token);

        localStorage.setItem("email", this.user.email);
        localStorage.setItem("token", JSON.stringify(response.data.token));

        this.setToken(objToken);

        if (!(objToken.situacao == "normal")) {
          this.$router.push({ name: "ResetPassword" });
        } else {
          this.$router.push({ name: "Dashboard" });
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        switch (error.status) {
          case 400:
            this.isOkResponse = false;
            this.isOkEmail = false;
            this.responseText = "Login e/ou senha inválidos!";
            this.showAlert = true;
            break;
          case 500:
            this.user.email = "";
            this.user.email = "";
            this.responseText = "Falha ao se logar, contate ao Administrator!";
            this.showAlert = true;
            break;
          default:
            break;
        }
      }
    },
    handleInputValue(propertyName, propertyValue) {
      this.user = Object.assign(
        {},
        this.user,
        this.setObjectProperty(this.user, propertyName, propertyValue)
      );
    },
    clickVerSenha() {
      if (this.typePassword === "password") {
        this.typePassword = "text";
      } else if (this.typePassword === "text") {
        this.typePassword = "password";
      }
    },
    isValid() {
      let isValidEmail = document.getElementById("email").validity.valid;
      let isValidPassword = document.getElementById("password").value.length;

      this.isOkEmail = isValidEmail;

      if (isValidPassword > 0) {
        this.isOkResponse = true;
      } else {
        this.isOkResponse = false;
      }

      //Desativa o disabled do button type submit(ao estado default)
      if (isValidEmail && isValidPassword > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    // parseJwt(token) {
    //   var base64Url = token.split(".")[1];
    //   var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //   var jsonPayload = decodeURIComponent(
    //     window
    //       .atob(base64)
    //       .split("")
    //       .map(function (c) {
    //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    //       })
    //       .join("")
    //   );

    //   return JSON.parse(jsonPayload);
    // },
    parseJwt(token) {
      return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
    },
  },
  computed: {
    ...mapGetters(["token"]),
  },
};
</script>
<style scoped>
#form {
  max-width: 513px;
  background-color: var(--white);
  border-radius: 16px;
  padding: 54px;
}
#logo {
  left: 24px;
  top: 64px;
  position: absolute;
}
.btnTyped {
  background-color: var(--blue-medium);
}
.btnUntyped {
  background-color: var(--lilac);
}
@media only screen and (max-width: 764px) {
  #logo {
    left: 0;
    top: 0;
    position: initial;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 800px) {
  #form {
    padding: 30px;
    margin: 20px;
  }
}
</style>
